import Taro, { getSystemInfoSync, nextTick } from '@tarojs/taro';

/**
 * 获取指定选择器的 DOM 节点的位置信息
 * 兼容微信小程序环境
 * @param selector - 选择器字符串
 * @returns Promise<Taro.NodesRef.BoundingClientRectCallbackResult | null>
 */
export const selectorQueryClientRect = (selector: string): Promise<Taro.NodesRef.BoundingClientRectCallbackResult | null> => {
  return new Promise((resolve, reject) => {
    try {
      // 创建选择器查询实例
      const query = Taro.createSelectorQuery();
      if (!query) {
        console.error('Taro.createSelectorQuery() 返回 null');
        reject(new Error('无法创建 SelectorQuery 实例'));
        return;
      }

      // 使用 nextTick 确保在 DOM 渲染完成后执行查询
      nextTick(() => {
        if (!selector) {

          resolve(null);
          return;
        }
        query
          .select(selector) // 选择指定的 DOM 节点
          .boundingClientRect((rect) => {
            if (!rect) {
              resolve(null);
            } else {
              // 如果找到元素，返回其位置信息
              resolve(Array.isArray(rect) ? rect[0] : rect);
            }
          })
          .exec(); // 执行查询
      });
    } catch (error) {
      // 捕获异常并记录错误日志
      console.error('selectorQueryClientRect 出现错误:', error);
      reject(error);
    }
  });
};

/**
 * 获取设备的系统信息
 * @returns Promise<any>
 */
export const getSystemInfo = () => {
  return new Promise(() => {
    return getSystemInfoSync();
  });
};
